import richText from "utilities/richText"
import Divider from "components/DynamicComponent/atoms/Divider"

function Question({ question, answer }) {
  return (
    <div>
      <div className="eyebrow pb-2 text-primary" aria-hidden>
        Q
      </div>
      <h3 className="text-primary font-semibold text-m2 pb-2">{question}</h3>
      <div>{richText(answer)}</div>
    </div>
  )
}

export default function QASection({ blok }) {
  return (
    <section className="bg-highlight-tint px-5 py-12 lg:py-16">
      <Divider allyHidden />
      <div className="flex flex-col lg:flex-row max-w-screen-xl mx-auto py-6 lg:py-12 lg:gap-4">
        <div className="lg:basis-1/4">
          <h2 className="text-primary pb-7">{blok.heading}</h2>
        </div>
        <div className="lg:basis-3/4 grid lg:grid-cols-2 gap-7">
          {blok?.questions?.map((question) => (
            <Question {...question} key={question._uid} />
          ))}
        </div>
      </div>
      <Divider allyHidden />
    </section>
  )
}
